import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcExplore = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Z",
  fill: "var(--mds-nav-icon-weak)",
  fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M10.435 8.855a2.5 2.5 0 0 0-1.581 1.58l-1.88 5.642a.75.75 0 0 0 .948.949l5.641-1.88a2.5 2.5 0 0 0 1.581-1.582l1.88-5.641a.75.75 0 0 0-.948-.949l-5.641 1.88Zm1.564 4.645a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
  fill: "var(--mds-nav-icon-accent)",
  fillRule: "evenodd"
})), "IcExplore");

export { IcExplore };
//# sourceMappingURL=ic-explore.js.map
